import Cookies from 'js-cookie';

if ($(location).attr("pathname") === "/project/index") {

    var viewDatagridOptions = {
        dataSource: [],
        filterValue: null,
        onRowPrepared: function (info) {
            if (info.rowType === 'data') {
                if (info.data.active === 0)
                    info.rowElement.addClass('inactive');
            }
        },
        columns: [
            {
                dataField: "id",
                allowSorting: false,
                caption: "",
                dataType: "string",
                width: 30,
                cellTemplate: function (container, options) {
                    editButton(container, options, 'project')
                }
            }, {
                dataField: "name",
                caption: "Projectnaam",
                dataType: "string",
                sortOrder: "asc",
                cellTemplate: function (container, options) {
                    $('<span><span class="badge badge-project" style="background-color: ' + options.data.color + ';"></span>' + options.data.name + '</span>')
                        .appendTo(container);
                }
            }, {
                dataField: "address",
                caption: "Adres",
                dataType: "string",
                visible: true
            },
            {
                dataField: "postal_code",
                caption: "Postcode",
                dataType: "string",
                visible: true
            },{
                dataField: "city",
                dataType: "string",
                caption: "Plaats"
            }, {
                dataField: "active",
                dataType: "string",
                visible: false
            },{
                dataField: "project_nr_mcn",
                dataType: "string",
                caption: "Projectnr mcn",
            }, {
                dataField: "project_nr_customer",
                dataType: "string",
                caption: "Projectnr klant"
            }, {
                dataField: "client.name",
                caption: "Opdrachtgever",
                dataType: "string",
                cellTemplate: function (container, options) {
                    $('<span><span class="badge badge-project" style="background-color: ' + options.data.client.color + ';"></span>' + options.data.client.name + '</span>')
                        .appendTo(container);
                }
            }, {
                caption: "",
                dataType: "string",
                width: 40,
                cellTemplate: function (container, options) {
                    if (options.data.active === 1) {
                        deactivateButton(container, options, 'project')
                    } else {
                        activateButton(container, options, 'project')
                    }
                }
            }]
    };

    $(function () {
        let gridContainer = $("#gridContainer");

        viewDatagridOptions.dataSource = JSON.parse(gridContainer.attr('data-projects'));

        let filterActive = Cookies.get('project_filter_active');
        if (filterActive === undefined) {
            filterActive = 1;
        } else {
            filterActive = parseInt(filterActive); // cast to int
        }
        if (filterActive) {
            viewDatagridOptions.filterValue = [["active", "=", "1"]];
        }

        // Initialize datagrid
        let datagridOptions = $.extend(defaultDatagridOptions, enableDatagridSelection, viewDatagridOptions);
        let dataGrid = gridContainer.dxDataGrid(datagridOptions).dxDataGrid("instance");

        // Initialize visibility checkbox
        toggleVisibilityDatafield(dataGrid, 'active', "1", 'Gedeactiveerde projecten weergeven', filterActive === 0, 'project_filter_active');
    });
}



// WEBPACK FOOTER //
// ./resources/js/components/projects.js